<template>
  <table width="100%">
    <tr>
      <td width="150">
        <a-checkbox v-model:checked="value">{{ text }}</a-checkbox>
      </td>
      <td>
        From
      </td>
      <td width="100">
        <div style="margin-left: 10px;">
          <a-select :default-value="timeStart" v-model="timeStart" style="width: 100%"" @change="onChangeTimeStart">
            <a-select-option v-for=" t in times" :key="t.i" :value="t.text">{{
          t.text
        }}</a-select-option>
          </a-select>
        </div>
      </td>
      <td>
        <div style="margin-left: 10px;">
          To
        </div>
      </td>
      <td width="100">
        <div style="margin-left: 10px;">
          <a-select :default-value="timeEnd" v-model="timeEnd" style="width: 100%"" @change="onChangeTimeEnd">
            <a-select-option v-for=" t in times" :key="t.i" :value="t.text">{{
          t.text
              }}</a-select-option>
          </a-select>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>

export default {
  //
  //
  //
  props: {
    text: String,
  },
  //
  //
  //
  components: {},
  //
  //
  //
  data() {
    return {
      value: false,
      timeStart: "00:00",
      timeEnd: "00:00",
      times: [
        { i: 0, text: "00:00" },
        { i: 1, text: "01:00" },
        { i: 2, text: "02:00" },
        { i: 3, text: "03:00" },
        { i: 4, text: "04:00" },
        { i: 5, text: "05:00" },
        { i: 6, text: "06:00" },
        { i: 7, text: "07:00" },
        { i: 8, text: "08:00" },
        { i: 9, text: "09:00" },
        { i: 10, text: "10:00" },
        { i: 11, text: "11:00" },
        { i: 12, text: "12:00" },
        { i: 13, text: "13:00" },
        { i: 14, text: "14:00" },
        { i: 15, text: "15:00" },
        { i: 16, text: "16:00" },
        { i: 17, text: "17:00" },
        { i: 18, text: "18:00" },
        { i: 19, text: "19:00" },
        { i: 20, text: "20:00" },
        { i: 21, text: "21:00" },
        { i: 22, text: "22:00" },
        { i: 23, text: "23:00" },
      ],
    };
  },
  //
  //
  //
  mounted() {

  },
  //
  //
  //
  methods: {
    //
    //
    //
    setData(value, timeStart, timeEnd) {
      // If value, timeStart, timeEnd = undefined
      // Then put default value
      if (value === undefined) {
        value = true
      }

      if (timeStart === undefined) {
        timeStart = "00:00"
      }

      if (timeEnd === undefined) {
        timeEnd = "00:00"
      }

      this.value = value;
      this.timeStart = timeStart;
      this.timeEnd = timeEnd;
    },
    //
    //
    //
    getData() {
      return {
        text: this.text,
        value: this.value,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
      }
    },
    //
    //
    //
    onChange(e) {
      this.value = e.target.checked;
    },
    //
    //
    //
    onChangeTimeStart(v) {
      this.timeStart = v;
    },
    onChangeTimeEnd(v) {
      this.timeEnd = v;
    }
  }
};
</script>

<style lang="scss"></style>
